import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import { postToken } from "redux/oidc/oidcFunctions";
import { TokenResponse } from "types/TokenResponse";
import { createUseStyles } from "react-jss";
import LoginHeader from "components/LoginHeader";
import { Grid, useMediaQuery } from "@material-ui/core";
import { getCurrentYear } from "utility/date";
import { useTranslation } from "react-i18next";
import Background from "img/Background.png";

const useStyles = createUseStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const Redirect = () => {
  const classes = useStyles();

  const { t } = useTranslation();

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  React.useEffect(() => {
    const makeRequest = async () => {
      const query = queryString.parse(location.search);

      if (query.error) {
        history.push("/error/techerror");
      }

      if (query.code && query.state) {
        try {
          // tslint:disable-next-line: await-promise
          const res = (await dispatch(
            postToken(query.code as string, query.state as string)
          )) as TokenResponse;

          if (res.AccessToken) {
            history.push("/");
          }
        } catch (error) {
          if (error.target.status === 400) {
            history.push("/error/nocustomership");
          } else {
            history.push("/error/techerror");
          }
        }
      }
    };

    // tslint:disable-next-line: no-floating-promises
    makeRequest();
  }, [location, dispatch, history]);

  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100%",
      }}
    >
      <LoginHeader />
      <div
        className={classes.container}
        style={{
          height: matchesMediaQuery
            ? "calc(100% - 270px)"
            : "calc(100% - 230px)",
        }}
      >
        <div
          style={{
            width: matchesMediaQuery ? "58%" : "100%",
            height: 500,
            maxWidth: 750,
            textAlign: "center",
          }}
        >
          <p style={{ color: "#4B7E17", fontSize: "1.9em" }}>
            {t("login_success")}
          </p>
          <p style={{ color: "#FFFFFF", fontSize: "1em" }}>
            {t("redirect_to_service")}
          </p>
        </div>
      </div>
      <Grid
        container
        style={{
          height: 47,
          background: "#1A1A1A",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#666666",
              textAlign: "center",
              fontSize: "min(max(.7em, 3vw), 1em)",
              margin: 0,
            }}
          >
            © {getCurrentYear()} Forea Capital Oy. All rights reserved.
            {matchesMediaQuery ? " | " : <br />}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://forea.fi/wp-content/uploads/BEST-EXECUTION-2019.pdf"
              style={{ color: "#666666", textDecoration: "none" }}
            >
              Best Execution (in Finnish){" "}
            </a>{" "}
            |{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://forea.fi/wp-content/uploads/Tietoja-ForeaCapitalOy.pdf"
              style={{ color: "#666666", textDecoration: "none" }}
            >
              Customer Information (in Finnish){" "}
            </a>
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Redirect);
